var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 7.5,
    fill: "black",
    fillOpacity: 0.8,
    stroke: "url(#paint0_linear_121_255)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_121_255)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 30,
    height: 2,
    fill: "url(#paint1_linear_121_255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 30,
    height: 2,
    fill: "url(#paint2_linear_121_255)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 31,
    width: 30,
    height: 2,
    fill: "url(#paint3_linear_121_255)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_121_255",
    x: 0,
    y: 7,
    width: 50,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.623529 0 0 0 0 0.313726 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_255",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_255",
    x1: 48.5704,
    y1: -154.723,
    x2: 13.2149,
    y2: 83.9257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_255",
    x1: 12,
    y1: 4.625,
    x2: 3.60162,
    y2: 15.7839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_255",
    x1: 12,
    y1: -2.375,
    x2: 3.60162,
    y2: 8.78394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_255",
    x1: 12,
    y1: 11.625,
    x2: 3.60162,
    y2: 22.7839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2f70e4822a0a2a03c69c13d19dd9d41f.svg";
export { ForwardRef as ReactComponent };